import React, { Fragment } from 'react';
import { withCookies } from 'react-cookie';
import { withRouter } from 'react-router-dom';

import { Container, Typography, Paper, Button } from '@material-ui/core'
import { ThemeProvider } from '@material-ui/styles'

import  PatronCheckout from '../components/PatronCheckout'
import { VerticalInsureOfferComponent, InsuranceOffer } from 'react-frontend-utils'
import { DocumentUploaderDownloaderComponent } from "../components/DocumentUploaderDownloaderComponent";
import { renderField  } from 'form-builder'
import { GenericTextField } from 'form-builder'
import { Field, refreshCalculations, computePaymentSum, computeFutureBalanceSum } from 'form-builder';

import AGTheme, { ThemeColors } from '../Theme'

import { Application } from '../models/Application'
import { Community } from '../models/Community'
import { Email, Currency, ManageDecimalField, RichTextDisplay, draftContentHasText } from 'react-frontend-utils'


export class Patron extends DocumentUploaderDownloaderComponent {
      
    _group;   //Group the patron requested
    _test;    //Testing requested
    _paper;   //paper submission requested
    _fieldParams; //Additional field parameters to pre-populate, arrives as array of name=value pair strings
    _alternate; //Alternate application (support) requested
    _origApplicationID; //ID of the Application related to the support request
    _renewalMembershipID; //ID of the Membership related to the renewal request
    _renewHmac; //HMAC to validate the renewal request
    _submitHmac; //HMAC to validate the submission request
    _email;     //Passed email for the form
    _internal;  //Using community support template
    _submitType;

    _insuranceAmount = 0;

    static showGeneratedErrorsAlert(component, generatedErrors) {
        component.showConfirmAlert("Error", "", 'red', "OK", null, null, 'black',
            <div>
                <Typography variant="body1" style={{marginBottom: 12}}>
                    Processing the form generated the following errors:
                </Typography>
                <ul style={{margin: 0, paddingLeft: 20}}>
                    {generatedErrors.map((error, index) => (
                        <li key={index}>
                            <Typography variant="body2" component="span">
                                {error}
                            </Typography>
                        </li>
                    ))}
                </ul>
            </div>
        );
    }

    constructor(props) {
        super(props);
    
        this._group = props.group ? encodeURIComponent(props.group) : null;  //Arrives with the query string set to the desired group
        this._test = props.test;                                             //Arrives with the test key
        this._paper = props.paper;                                           //Arrives with the paper key
        this._fieldParams = props.fieldParams ? props.fieldParams : [];       //Arrives with an array of additional field parameters to pre-populate, as name=value pair strings
        this._origApplicationID = props.origApplicationID ? encodeURIComponent(props.origApplicationID) : null;    //Arrives with the original Application ID
        this._renewalMembershipID = props.renewalMembershipID ? encodeURIComponent(props.renewalMembershipID) : null;    //Arrives with the renewal Membership ID
        this._renewHmac = props.renewHmac ? encodeURIComponent(props.renewHmac) : null;    //Arrives with renewal HMAC
        this._alternate = props.alternate;                    //Arrives with the alternate (support) flag set
        this._email = props.email;    //Arrives with an email address
        this._internal = props.internal;   
        if (this._internal)  //make this a support request
            this._alternate = true;         
        this._submitType = this._alternate ? "Request" : "Application";

        this.state.application = null;                                       //The Application object.  Null if not found or Application Object when fetched.
        this.state.fetchComplete = false;
        this.state.fetchError = null;                                           //Error on fetch
        
        this.state.community = null; 
        this.state.submitting = false;              //true once submitted has been pressed
        this.state.submitted = false;               //true when submitted
        
        this.state.submitTried = false;
        this.state.paymentSum = 0.0;                //The calculated payment sum
        this.state.futureBalanceSum = 0.0;           //The calculated future balance sum
        this.state.paymentError = null;             //Error on payment calculation 

        this.state.clientSecret = null;             //When payment required, the secret that is passed to stripe
        this.state.paymentRequired = false;
        this.state.insuranceOffer = null;

        this.state.paperPaymentAmount = null;       // must be entered
        this.state.checkInfo = null;       // must be entered

        this.state.legacyEmailInvalid = false;
        this.state.appEmailField = null;  //If the Application has an ApplicationEmailField, this is set to it, and the patronData is set to the email passed in the URL (if any)
    }
    
    
    
    /**
     * When the page loads, immediately fetch the full application
     */
    componentDidMount() {
        super.componentDidMount();       
        window.addEventListener("resize", this._updateSize);
        
        if (!this._group) {
            this.showConfirmAlert("No Community", "You did not arrive with a link from your Community", 'red');
        }
        else
            this._fetchCommunityInfo(); 
        
    }

    componentWillUnmount() {
        super.componentWillUnmount();
        window.removeEventListener("resize", this._updateSize);
    }

    //callback when window changes size
    _updateSize = () => {
        this.forceUpdate();
    }

    
    _fetchCommunityInfo = () => {
        
        this.incrementBusy();
        
        const queryString = "?group=" + this._group;
        
        this.secureJSONFetch("/patron/groupinfo", {},
                             this._fetchStatusCallback, this._fetchErrorCallback, queryString); 
    }
    
    _fetchStatusCallback = (response) => {

        if (response) {
            const community = new Community(response);
            this.setState({community: community});
            
            //If we are accepting (or this is a test or internal), go fetch the Application, leave busy and fetching not complete
            if (community.status() === Community.Status.ACCEPTING || this._test || this._internal || (this._alternate && community.supportReqAcceptedAlways)) {
                this._fetchApplication(); 
                return;
            }
            else {
                this.setState({application: null, fetchComplete: true});  //fetch done, no application
            }
            
        }
        this.decrementBusy();

    }
   
    
    _fetchApplication = () => {
                
        let queryString = "?group=" + this._group;
        if (this._test)
            queryString += "&test=" + this._test;

        if (this._alternate) {
            queryString += "&support=true";
            if (this._origApplicationID)
                queryString += "&origApplicationID=" + this._origApplicationID;
        }

        if (this._paper)
            queryString += "&paper=true";

        if (this._renewalMembershipID)
            queryString += "&renewalMembershipID=" + this._renewalMembershipID;

        if (this._renewHmac)
            queryString += "&renewHmac=" + this._renewHmac;

        // Pass through each stripped field pair as its own fields parameter; backend handles decode/splitting.
        if (this._fieldParams.length > 0) {
            this._fieldParams.forEach((pair) => {
                queryString += "&fields=" + encodeURIComponent(String(pair));
            });
        }

        const url = this._internal ? "/community/application" : "/patron/application";

        this.secureJSONFetch(url, {}, this._fetchApplicationCallback, this._fetchErrorCallback, queryString); 
        
    }
   
    
    //Callback for fetching Application - response is an Application
    _fetchApplicationCallback = (response) => {
        if (response) {            
            const app = new Application(response, true);

            // If the form has an ApplicationEmailField with the name "applicationEmail" set the patronData to the email passed in the URL (if any)
            const applicationEmailFieldSet = Field.findFieldByName(app.fieldTree, "applicationEmail");
            const appEmailField = applicationEmailFieldSet ? applicationEmailFieldSet.field : null;
            if (appEmailField && appEmailField.type === "ApplicationEmail") {
                if (this._email)
                    appEmailField.patronData = this._email;        // pre-fill the email field with the email passed in the URL (if any)
                this.setState({appEmailField: appEmailField});
            }
            else {
                this._legacyEmailChanged(this._email); //legacy email, not in the form
            }

            this.setState({application: app, fetchComplete: true});  //set to retrieved application
            this._fieldChanged();  //refresh

        }            
        this.decrementBusy();
    }
    

    _fetchErrorCallback = (error) => {
        this.decrementBusy();
        this.setState({submitting: false, fetchComplete: true, fetchError: error, application: null});  //fetch done, but with error and no application
    }
  
    
    _fieldInputError = (field, error) => {
        this.showConfirmAlert("Error in Field \"" + field + "\"", error, 'red');
        this.forceUpdate();
    }
    
    //Called when a field is updated or on first load of Application. Refresh all calculations
    _fieldChanged = (field, newValue) => {
        
        const ap = this.state.application;

        refreshCalculations(ap.fieldTree, ap.fieldCalculations, ap.constants, (error) => console.error(error));

        try {
            const paymentSum = computePaymentSum(ap.fieldTree, ap.fieldCalculations, ap.constants);
            if (Number.isNaN(paymentSum) || paymentSum < 0.0)
                throw new Error("Calculated payment amount invalid");

            const futureBalanceSum = computeFutureBalanceSum(ap.fieldTree, ap.fieldCalculations, ap.constants);
            if (Number.isNaN(futureBalanceSum) || futureBalanceSum < 0.0)
                throw new Error("Calculated future balance amount invalid");

            this.setState({paymentSum: paymentSum, futureBalanceSum: futureBalanceSum, paymentError: null});
        } catch (error) {
            this.setState({paymentSum: null, paymentError: error.toString()});
        }

        this.forceUpdate();
    }
   
    _submitApplication = () => {
        
        if (this.state.application.isMissingData()) {
            this.showConfirmAlert("Missing Data", "One or more fields are required. If your browser auto-filled the form, you may get this message. Try clicking in the auto-filled fields.", 'red');
            this.setState({submitTried: true});
            return;
        }

        if (this.state.application.hasErroredField()) {
            this.showConfirmAlert("Invalid Data", "One or more fields have an error", 'red');
            this.setState({submitTried: true});
            return;
        }

        const generatedErrors = this.state.application.getGeneratedErrors();
        if (generatedErrors && generatedErrors.length > 0) {
            Patron.showGeneratedErrorsAlert(this, generatedErrors);
            this.setState({submitTried: true});
            return;
        }
        
        let appEmail;
        if (this.state.appEmailField)     // submission email in the Form, overrides legacy email
            appEmail = this.state.appEmailField.patronData;
        else
            appEmail = this._email;  //legacy email, not in the form

        if (!appEmail || !Email.validateEmail(appEmail)) {
            this.showConfirmAlert("Invalid Email", "Application email is missing or invalid.", 'red');
            this.setState({submitTried: true, legacyEmailInvalid: true});
            return;
        }

          
        this.state.application.submitterEmail = appEmail;  //set the submitter email in the Application

        if (this.state.application.isTooLarge()) {
            this.showConfirmAlert(this._submitType + " too Large", "You may need to remove some large attachments", 'red', 'Cancel', this._doSubmit, 'Try Anyway');
            return;
        }
        
        if (this.state.paymentError) {
            this.showConfirmAlert("Payment Error", "There is a problem calculating the correct payment", 'red');
            return;
        }

        if (this._paper && this.state.paperPaymentAmount == null) {
            this.showConfirmAlert("Missing Payment Amount", "Enter the amount actually paid with the paper application", 'red');
            return;
        }

        this.state.application.calculatedPaymentAmount = this.state.paymentSum;
        this.state.application.calculatedFutureBalanceAmount = this.state.futureBalanceSum;
        this.state.application.paperPaymentAmount = this.state.paperPaymentAmount;
        this.state.application.checkInfo = this.state.checkInfo;
        console.log("Calculated Payment: ", this.state.application.calculatedPaymentAmount);
        console.log("Calculated Future Balance: ", this.state.application.calculatedFutureBalanceAmount);
        this._doSubmit();
    }
    
    _doSubmit = () => {

        const url = this._internal ? "/community/application" : "/patron/application";

        this.incrementBusy();
        this.setState({submitting: true, submitTried: true});
        this.secureJSONFetch(url, 
                             {method: "POST", body: this.state.application.toJsonForPost()}, 
                             this._submitComplete,
                             this._submitErrorCallback);    
        
    }

    _submitErrorCallback = (error) => {
        this.showConfirmAlert("Error", error, 'red');
        this.decrementBusy();
        this.setState({submitting: false});
    }
    
    _submitComplete = (response) => {
        this.decrementBusy();

        if (response) { 
            this._submitHmac = response.hmac;
            this.setState({submitted: true, submitting: false, paymentRequired: response.paymentRequired}); 

            if (response.insuranceOffer) {
                // If there is an insurance offer available, create an InsuranceOffer instance and show insurance.
                const insuranceOffer = new InsuranceOffer(response.insuranceOffer, response.applicationId);
                this.setState({insuranceOffer: insuranceOffer});
            }
            else if (response.paymentRequired)  // otherwise jump right to retrieving the payment intent
                this._retrievePaymentIntent(response.applicationId); 

            // else - free, no payment required - show success message
        }
        else   // internal submission, no response received
            this.setState({submitted: true, submitting: false, paymentRequired: false}); 

    }

    _retrievePaymentIntent = (applicationId) => {
        this.incrementBusy();
        const hmac = encodeURIComponent(this._submitHmac);
        this.secureJSONFetch("/patron/paymentIntent",
                             {method: "POST"}, 
                             this._retrievePaymentIntentComplete,
                             this._retrievePaymentIntentError,
                             "?id=" + applicationId + "&group=" + this._group + "&hmac=" + hmac);    
    }

    // Return the patron to the form; the Application was already inserted, so resubmitting creates a new one
    _retrievePaymentIntentError = (error) => {
        this.showConfirmAlert("Error", error, 'red');
        this.decrementBusy();
        this.setState({submitted: false, submitting: false, paymentRequired: false, clientSecret: null, insuranceOffer: null});
        this._insuranceAmount = 0;
    }

    _retrievePaymentIntentComplete = (response) => {
        this.decrementBusy();
        if (response)
            this.setState({clientSecret: response, paymentRequired: true});
    }
    
    _insuranceComplete = (amount) => {
        this._retrievePaymentIntent(this.state.insuranceOffer.coveredPurchaseId);
        this._insuranceAmount = amount;
        this.setState({insuranceOffer: null});
    }
  
  
    _legacyEmailChanged = (userValue) => {

        if (userValue && !Email.validateEmail(userValue)) {
            this.showConfirmAlert("Error", "Receipt email \"" + userValue + "\" address not valid", 'red');
            this.setState({legacyEmailInvalid: true});
            return;
        }

        console.log("Legacy email changing to " + userValue);
        this._email = userValue;    
        this.setState({legacyEmailInvalid: false});
    }
  

    //Patron cancels the payment, returns to the Application
    _returnFromPayment = () => {
        this.setState({submitted: false, paymentRequired: false, clientSecret: null, insuranceOffer: null});
        this._insuranceAmount = 0;
    }


    _patronReasonNotAccepting() {

        const status = this.state.community.status();
        switch (status) {
            case Community.Status.WAITING:      // for these cases, if the custom text is set, we use that
            case Community.Status.FINISHED:
                if (draftContentHasText(this.state.community.notAcceptingCustomText))       // if there is content 'text' then use it
                    return <RichTextDisplay draftContent={this.state.community.notAcceptingCustomText}/>;
                //fallthrough
            default:
                return <Typography variant="h5" align='center'>{status.patronReason}</Typography>;   // otherwise, use the status reason
        }
    }

    render() {

        const fetchText = this._alternate ? "Support Form" : "Application";
        let errMessage = "We're sorry, something went wrong retrieving your " + fetchText + ". Please try again later."

        if (this._internal)  //alternate error message
            errMessage = "Unable to retrieve internal support form. Try logging in first.";

        if (this._paper)
            errMessage = "Unable to retrieve paper Application form. Try logging in first.";

        const fetchErrorDetail = this.state.fetchError ? this.state.fetchError : null;
        
        //Fetching not finished or no community retrieved
        if (!this.state.fetchComplete || this.state.community === null) {
            
            return <ThemeProvider theme={AGTheme}>
                        <Fragment>
                            {this.getConfirmAlertComponent()}
                            {this.getBusyComponent('center', {marginTop: 60})}
                            {this.state.fetchComplete ?                      
                                <Typography variant="h4" align='center' style={{color: 'red', marginTop: 60}}>We're sorry, something went wrong. Please try again later.</Typography>
                                :
                                <Typography variant="h4" align='center' style={{color: ThemeColors.appBarBackground, fontWeight: 'bold', marginTop: 60}}>{"Getting your " + fetchText + "..."}</Typography>                            
                            }
                        </Fragment>
                    </ThemeProvider>;
        }
        
        //Submit complete, and no payment required - show success message
        if (this.state.submitted && !this.state.paymentRequired) {
            return <ThemeProvider theme={AGTheme}>
                        <div style={{textAlign: 'center', marginTop: 40}}>
                            <Typography variant="h4" style={{color: 'green', fontWeight: 'bold', marginBottom: 10}}>
                                <span style={{marginRight: 20}}>✓</span>{this._submitType + " Submitted"}
                            </Typography>  
                        </div>
                    </ThemeProvider>;
        }
           
        
    
        const ap = this.state.application;  //may or may not have an application, only if accepting applications
        const status = this.state.community.status();  //if fetch done, we have a community status

        const patronReasonNotAccepting = this._patronReasonNotAccepting();
 
        const renderParams = {forPatron: true, 
                             documentUploader: this.documentUploader,
                             documentDownloader: this.documentDownloader,
                             constants: ap ? ap.constants : null,
                             onChange: this._fieldChanged, 
                             onError: this._fieldInputError};
 
        const themeColor = this.state.community.primaryColor ? this.state.community.primaryColor : 'black';
        const backgroundColor = this.state.community.backgroundColor ? this.state.community.backgroundColor : 'white';

        const submitButtonText = (this.state.paymentSum > 0 && !this._paper) ? "Continue to Payment ➔" : ("✓ Submit " + this._submitType);

        let emailBorder = this.state.legacyEmailInvalid ? {border: '1px solid red', padding: 3, paddingTop: 8} : {border: 'none', padding: 0};

        //If we are accepting applications (or this is test) and we have an Application, show it.  Otherwise show the reason why the Community is not accepting applications

        let title = this.state.community.extendedName;
        if (this._internal)
            title += " Community Support Request";
        else if (this._alternate)
            title += " Patron Support Request";
        else {
            if (ap && ap.isRenewal)
                title += " Renewal";
            title += " Application";
        }
        
        
        
        const responseType = this._alternate ? "responses" : "status on your Application";
        return (
    
            <ThemeProvider theme={AGTheme}>
                <div style={{backgroundColor: backgroundColor, paddingBottom: 20}}>                    
                    <Container disableGutters={true} style={{padding: 10}}>

                        {!this.state.community.suppressTitle || this._internal ?     
                            <Typography variant="h4" align='center' style={{color: themeColor, marginBottom: 20}}>{title}</Typography> 
                            : 
                            <div style={{marginTop: 20}}/>
                        }

                        {(status === Community.Status.ACCEPTING || this._test || (this._alternate && this.state.community.supportReqAcceptedAlways)) ? 
                            
                            (ap ?

                                <div>
                                
                                    {this.getConfirmAlertComponent()}                    
                                    {ap.testing ? <Typography variant="h5" align='right' style={{marginBottom: 20, textAlign: 'center', fontWeight: 'bold', color: 'white', backgroundColor: 'red'}}>TEST MODE</Typography> : null}       

                                    <div style={{display: this.state.submitted ? 'none' : 'block'}}>
                                        <Paper elevation={3} style={{padding: 15}}> 

                                            <Typography align='right' variant="body2" style={{fontStyle: 'italic'}} >* Required Field</Typography>  

                                            {this.state.appEmailField ? null :
                                                <Fragment>
                                                    <Typography variant="body1" style={{fontStyle: 'italic', marginLeft: 10}} >{"We will send " + responseType + " to the email address below"}</Typography>  
                                                    <div style={{...emailBorder, marginTop: 10}}>
                                                        <GenericTextField label="Your Email Address *"
                                                                        initialValue={this._email}
                                                                        idleTimeout={7000}
                                                                        onFieldChange={this._legacyEmailChanged}/>
                                                    </div>
                                                </Fragment>
                                            }

                                            {renderField(ap.fieldTree, 0, renderParams, this.state.submitTried)}

                                        </Paper>

                                        {this._paper ? 
                                            <Fragment>
                                                <Typography align='center' variant="body1" style={{marginTop: 40}} >{"Required Payment: " + Currency.round(ap.calculatedPaymentAmount) + " " + ap.currency}</Typography>  

                                                <ManageDecimalField style={{margin: 'auto', marginTop: 30, maxWidth: 300}}
                                                                    json="ActualPayment" 
                                                                    label={"Actual Payment Amount (USD only)"}
                                                                    autoAccept={true}
                                                                    hasNever={false}
                                                                    fontSize={18}
                                                                    hasNegative={false}
                                                                    hideButtons={true}
                                                                    decimalPlaces={2}
                                                                    onFieldChange={(fieldName, userValue) => {
                                                                        this.setState({paperPaymentAmount: userValue});
                                                                    }}/>
                                                <GenericTextField style={{margin: 'auto', marginTop: 30, maxWidth: 800}}
                                                                  label="Check Information"
                                                                  onFieldChange={(value) => this.setState({checkInfo: value})}/>
                                            </Fragment>
                                            : null
                                        }

                                        <div style={{display: 'flex', justifyContent: 'center', marginTop: 20, marginBottom: 30}}>
                                            <Button disabled={this.state.submitting} variant='contained' color='primary' onClick={this._submitApplication}>{submitButtonText}</Button>
                                        </div>
                                    </div>

                                    {this.state.insuranceOffer ? 
                                        <VerticalInsureOfferComponent offer={this.state.insuranceOffer} group={this._group}
                                                                 hmac={this._submitHmac}
                                                                 acceptUrl="/patron/acceptInsurance"
                                                                 declineUrl="/patron/declineInsurance"
                                                                 communityName={this.state.community.extendedName}
                                                                 productCategory="Application"
                                                                 onClose={this._insuranceComplete}
                                                                 loadingMessage="Reviewing application, please be patient..."/>
                                        : null
                                    }

                                    {this.state.paymentRequired && this.state.clientSecret ? 

                                        <PatronCheckout returnToApplication={this._returnFromPayment} 
                                                        paymentDescription={"Amount to Charge: " + Currency.round(ap.calculatedPaymentAmount + this._insuranceAmount) + " " + ap.currency}
                                                        purchaseComplete={() => this.setState({paymentRequired: false}) /* Payment complete, will trigger success message*/}
                                                        clientSecret={this.state.clientSecret}
                                                        purchaseNote={this._insuranceAmount > 0 ? "The payment will be split into two charges: one for the application and one for the protection plan" : null}
                                                        email={ap.submitterEmail}/>
                                        : null
                                    }


                                    {this.state.isBusy ? this.getBusyComponent('center', {marginTop: 20}) : <div style={{height: 50}}/>}
                                    
                                </div>
                                :
                                <div style={{textAlign: 'center'}}>
                                    <Typography variant="h5" style={{color: 'red'}}>{errMessage}</Typography>
                                    {fetchErrorDetail ? <Typography variant="body2" style={{color: 'red', marginTop: 30}}>{fetchErrorDetail}</Typography> : null}
                                </div>

                            )               
                            : 
                            <div>
                                {this._alternate ?   
                                    <Typography variant="h5" align='center'>We're sorry, but we are not currently accepting support requests. Please contact your community directly.</Typography> 
                                    : 
                                    <Fragment>{patronReasonNotAccepting}</Fragment>
                                }
                            </div>
                        }
                            
                    </Container>
                    
                </div>
            </ThemeProvider>
        );
    }
  
}

export default withCookies(withRouter(Patron));



